<!-- 营销 -->

<template>
    <div class='maketing_box'>
        <div class="container" style="padding-bottom: 40px;">

            <div class="min_title_box">
                <div class="name_box">Flash sale</div>
                <div class="coupon_nav" style="cursor: pointer;" @click="goCoupons">
                    <span>My coupons</span>
                    <img src="@/assets/images1/37.png" alt="" class="arrow">
                </div>
            </div>

            <div class="banner_box">
                <img :src="noticeBgc" alt="">
                <!-- <img src="@/assets/images1/38.png" alt=""> -->
            </div>

            <good-list-2 :goodList="FlashList" :Time="endTimeList" v-if="FlashList.length > 0" />
        </div>
    </div>
</template>

<script>
import GoodList2 from '@/components/GoodList2/GoodList2.vue'
export default {
    components: { GoodList2 },
    data() {
        return {
            noticeBgc: '',
            FlashList: [],
            endTimeList: [], //倒计时时间
        }
    },
    mounted() {
        // 类型（0-底部文本框、1-顶部注意事项背景图、2-热销、3-首页品牌、4-秒杀）
        this.$get("system/content/list?type=4").then(res => {
            this.noticeBgc = res.rows[0].content;
        })
        this.listFlashApi();
    },
    methods: {
        // 秒杀
        async listFlashApi() {
            try {
                const res = await this.$get('system/sale/listFlash', {
                    pageNum: 1,
                    pageSize: 999
                });
                this.FlashList = res.rows || [];
                this.endTimeList = [];
                //定义一个新数组，将活动的结束时间参数提成一个单独的数组
                for (let i = 0; i < this.FlashList.length; i++) {
                    var objs = {};
                    objs.eTime = this.FlashList[i].endTime
                    this.endTimeList.push(objs)
                }
                console.warn(res.rows, "秒杀")
            } catch (error) {
            }
        },
        goCoupons() {
            this.$router.push({
                path: "coupons"
            })
        }
    },
}
</script>

<style lang='scss' scoped>
@import './marketing.scss';
</style>